import type { Review } from '@homeviews/models'
export const getReviewValue = (
  key: string,
  review: Review,
  checkIsDefined = false,
) => {
  if (checkIsDefined && review?.[key] === 'N/A') {
    return ''
  }

  if (review?.[key] && review?.[key] !== 'N/A') {
    return review[key]
  }

  return ''
}
